import { HttpService } from "../http";
import { getBaseUrl } from "@root/store/selectors/features";
import { store } from "@root/store";

export class EquipmentService extends HttpService {
  baseUrl = getBaseUrl(store.getState());

  fetchEquipmentsByDepartment = async (
    id: number,
    payload: any = {}
  ): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/equipments/department/${id}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
